module.exports = __webpack_public_path__ + "static/cfg-1-9e70b620ca5b5c8ef7cf02ff286c3b3d.jpeg";